// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__Chh08","spinning":"style_spinning__cXG4t","text":"style_text__L014Q","dark":"style_dark__zD8hT","clean":"style_clean__bBype"};